module.exports = __webpack_public_path__ + "img/right-side-menu-layers.a963148d.svg";